export const TOGGLE_SIDE_MENU = "TOGGLE_SIDE_MENU";
export const OPEN_SIDE_MENU = "OPEN_SIDE_MENU";
